import { useEffect, useRef } from "react";
import Samalyot from "../images/samalyot.svg";

export default function PlaneCanvas() {
  const canvasRef = useRef(null);
  const planeImgRef = useRef(new Image());

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const updateCanvasSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = document.body.scrollHeight;
    };

    updateCanvasSize();
    window.addEventListener("resize", updateCanvasSize);
    planeImgRef.current.src = Samalyot;
    const startX = 200;
    const startY = 100;
    const controlX1 = startX + 2600;
    const controlY1 = startY + 400;
    const controlX2 = startX + 300;
    const controlY2 = startY + 800;
    const endX = startX;
    const endY = startY + 4800;

    let t = 0;
    function drawPath() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.strokeStyle = "#FF9D00";
      ctx.lineWidth = 3;
      ctx.setLineDash([20, 10]);
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.bezierCurveTo(controlX1, controlY1, controlX2, controlY2, endX, endY);
      ctx.stroke();
    }

    function getBezierPoint(t) {
      const x =
        (1 - t) ** 3 * startX +
        3 * (1 - t) ** 2 * t * controlX1 +
        3 * (1 - t) * t ** 2 * controlX2 +
        t ** 3 * endX;
      const y =
        (1 - t) ** 3 * startY +
        3 * (1 - t) ** 2 * t * controlY1 +
        3 * (1 - t) * t ** 2 * controlY2 +
        t ** 3 * endY;
      return { x, y };
    }
    let fadeOutOpacity = 1;

    function animatePlane() {
      drawPath();

      const { x, y } = getBezierPoint(t);
      const planeImg = planeImgRef.current;
      ctx.globalAlpha = fadeOutOpacity;
      ctx.drawImage(planeImg, x - 50, y - 50, 100, 100);

      t += 0.0005;

      if (t >= 0.9 && fadeOutOpacity > 0) {
        fadeOutOpacity -= 0.005;
      }

      if (t >= 1) {
        t = 0;
        fadeOutOpacity = 1;
      }

      requestAnimationFrame(animatePlane);
    }

    planeImgRef.current.onload = () => {
      animatePlane();
    };

    return () => {
      window.removeEventListener("resize", updateCanvasSize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 10,
        pointerEvents: "none",
        width: "100%",
        overflow: 'hidden'
      }}
    />
  );
}
